import { fetchGroupById, fetchGroupByUserId, fetchUserByUserId } from 'utils/queries'

import { UserType } from 'types/user'

const computeIdentifierToShow = (combinedCategoriesAndProgramIds: string[]) => {
  const isCurrentUserUpspace = combinedCategoriesAndProgramIds.find((id) => id === 'upspace')
  if (isCurrentUserUpspace) return 'upspace'

  const isUpspace = combinedCategoriesAndProgramIds.find(
    (id) => id !== 'upspace' && id !== 'friends' && id !== 'followers',
  )
  if (isUpspace) return isUpspace

  const isFriends = combinedCategoriesAndProgramIds.find((id) => id === 'friends')
  if (isFriends) return isFriends

  const isFollowers = combinedCategoriesAndProgramIds.find((id) => id === 'followers')
  if (isFollowers) return isFollowers

  return combinedCategoriesAndProgramIds[0]
}

export const computeWhereToText = async (
  creator: UserType,
  combinedCategoriesAndProgramIds: string[],
) => {
  const identifierToShow = computeIdentifierToShow(combinedCategoriesAndProgramIds)

  let newWhereToText = ''
  if (identifierToShow === 'upspace') {
    const program = await fetchGroupByUserId({ userId: creator.id })
    if (program) {
      newWhereToText = program.title ?? `${creator.firstName} ${creator.lastName}'s Group`
    }
  } else if (identifierToShow[0] !== 'f') {
    const program = await fetchGroupById(identifierToShow)

    if (program && program.title) {
      newWhereToText = program.title
    } else if (program && program.trainer) {
      const programTrainer = await fetchUserByUserId({ userId: program?.trainer.id })
      if (programTrainer) {
        newWhereToText = `${programTrainer.firstName} ${programTrainer.lastName}'s Group`
      }
    }
  } else if (identifierToShow === 'friends') {
    newWhereToText =
      identifierToShow.charAt(0).toUpperCase() + identifierToShow.slice(1).toLowerCase()
  } else if (identifierToShow === 'followers') {
    newWhereToText = creator ? `${creator?.firstName} ${creator?.lastName}` : ''
  }

  if (newWhereToText.length > 15) {
    newWhereToText = newWhereToText.slice(0, 12).trimEnd().concat('...')
  }

  if (newWhereToText.length > 0 && combinedCategoriesAndProgramIds.length > 1) {
    newWhereToText = `${newWhereToText} +${combinedCategoriesAndProgramIds.length - 1}`
  }

  return newWhereToText
}
